<template>
  <HelperComponentV2 v-if="clubVersion === 'v2'"/>
  <div class="containerx" v-else>
    <div>
      <div :class="{ spaceHelper: !isMobile, spaceHelperMobile: isMobile }">
        <span v-if="customHelper">
          <iframe
            v-if="linkIframe !== null && linkIframe !== ''"
            :src="linkIframe"
            width="100%"
            frameborder="0"
          ></iframe>
        </span>
        <span v-if="!customHelper && !loading">
          <div class="spaceTitle">
            <p>
                {{ $t('helper.title') }}
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 15.92V18.92C21.0011 19.1985 20.9441 19.4741 20.8325 19.7293C20.7209 19.9845 20.5573 20.2136 20.3521 20.4018C20.1468 20.5901 19.9046 20.7335 19.6407 20.8227C19.3769 20.9119 19.0974 20.945 18.82 20.92C15.7428 20.5856 12.787 19.5341 10.19 17.85C7.77382 16.3146 5.72533 14.2661 4.18999 11.85C2.49997 9.24118 1.44824 6.27097 1.11999 3.17997C1.095 2.90344 1.12787 2.62474 1.21649 2.3616C1.30512 2.09846 1.44756 1.85666 1.63476 1.6516C1.82196 1.44653 2.0498 1.28268 2.30379 1.1705C2.55777 1.05831 2.83233 1.00024 3.10999 0.999975H6.10999C6.5953 0.995198 7.06579 1.16705 7.43376 1.48351C7.80173 1.79996 8.04207 2.23942 8.10999 2.71997C8.23662 3.68004 8.47144 4.6227 8.80999 5.52997C8.94454 5.8879 8.97366 6.27689 8.8939 6.65086C8.81415 7.02482 8.62886 7.36809 8.35999 7.63998L7.08999 8.90997C8.51355 11.4135 10.5864 13.4864 13.09 14.91L14.36 13.64C14.6319 13.3711 14.9751 13.1858 15.3491 13.1061C15.7231 13.0263 16.1121 13.0554 16.47 13.19C17.3773 13.5285 18.3199 13.7634 19.28 13.89C19.7658 13.9585 20.2094 14.2032 20.5265 14.5775C20.8437 14.9518 21.0122 15.4296 21 15.92Z"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <div class="textToTutors" v-if="permission">
            <p>
              {{ $t('helper.tutors') }}
              <a
                href="https://help.greenn.com.br/pt-br/category/greenn-club-1jo7ejt/"
                target="_blank"
                >{{ $t('helper.link') }}</a
              >
            </p>
          </div>
          <div class="spaceDados">
            <div
              :class="{ headerFlex: !isMobile, headerFlexMobile: isMobile }"
            >
              <p class="title">{{ $t('helper.label_title') }}</p>
              <div>
                <button
                  class="btnNewChamado"
                  v-if="!permission"
                  :class="{ width100: isMobile }"
                  @click="openModal"
                >
                  {{ $t('helper.btn_new') }}
                </button>
              </div>
            </div>
            <span class="tosearch">
              <div class="inputSearch" :class="{ width100: isMobile }">
                <img
                  src="@/assets/icons/search.svg"
                  @click="getAllChamado('search')"
                  class="Pointer search"
                />
                <b-form-input
                  class="input-busca"
                  @change="getAllChamado('search')"
                  v-model="searchTicket"
                  :placeholder="$t('helper.pesquisa')"
                ></b-form-input>
              </div>
            </span>
            <div
              :class="{
                gridListMenu: !isMobile,
                gridListMenuMobile: isMobile,
              }"
            >
              <div
                class="menu"
                @click="getList('')"
                :class="{ activeList: selectedList === '' }"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
                    stroke="#333"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17 21V13H7V21"
                    stroke="#333"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 3V8H15"
                    stroke="#333"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ $t('helper.todos') }}
              </div>
              <div
                class="menu"
                @click="getList('open')"
                :class="{ activeList: selectedList === 'open' }"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 10L20 15L15 20"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 4V11C4 12.0609 4.42143 13.0783 5.17157 13.8284C5.92172 14.5786 6.93913 15 8 15H20"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ $t('helper.abertos') }}
              </div>
              <div
                class="menu"
                @click="getList('concluded')"
                :class="{ activeList: selectedList === 'concluded' }"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                {{ $t('helper.fechados') }}
              </div>
            </div>
            <div>
              <div class="animationOpacity2">
                <div class="spaceTable" v-if="AllChamados.length >= 1">
                  <div :class="{ header: !isMobile, headerMobile: isMobile }">
                    <div>{{ $t('helper.title_chamadoz') }}</div>
                    <div v-if="!isMobile">{{ $t('helper.solicitante') }}</div>
                    <div v-if="!isMobile">{{ $t('helper.status') }}</div>
                    <div v-if="!isMobile">{{ $t('helper.aberto_em') }}</div>
                    <div>{{ $t('helper.evolucao') }}</div>
                    <div>{{ $t('helper.acao') }}</div>
                  </div>
                  <div class="itens">
                    <div
                      v-for="(item, index) in AllChamados"
                      :key="item.id"
                      :class="{
                        spaceItens: !isMobile,
                        spaceItensMobile: isMobile,
                        activeRow: item.active,
                      }"
                      :data-id="item.id"
                    >
                      <div
                        :class="{
                          flexPointer: item.unread_messages_count >= 1,
                        }"
                      >
                        <div
                          class="pointerMsg"
                          v-if="item.unread_messages_count >= 1"
                        ></div>
                        <div
                          v-if="item.last_message_is_mine"
                          @click="toggleActive(index)"
                          class="txt"
                        >
                          {{ item.subject }}
                        </div>
                        <div v-else @click="toggleActive(index)" class="txt2">
                          {{ item.subject }}
                        </div>
                      </div>
                      <div v-if="!isMobile">
                        <div @click="toggleActive(index)" class="txt">
                          {{ item.member.name }}
                        </div>
                      </div>
                      <div v-if="!isMobile">
                        <div
                          @click="toggleActive(index)"
                          class="txt"
                          v-if="item.status === 'open'"
                        >
                          {{ $t('helper.aberto') }}
                        </div>
                        <div
                          @click="toggleActive(index)"
                          class="txt"
                          v-else-if="item.status === 'concluded'"
                        >
                          {{ $t('helper.fechado') }}
                        </div>
                        <div @click="toggleActive(index)" class="txt" v-else>
                          {{ item.status }}
                        </div>
                      </div>
                      <div v-if="!isMobile">
                        <div @click="toggleActive(index)" class="txt">
                          {{ item.created_at | moment("DD/MM/YYYY HH:mm") }}
                        </div>
                      </div>
                      <div>
                        <div @click="toggleActive(index)" class="txt">
                          {{ item.updated_at | moment("DD/MM/YYYY HH:mm") }}
                        </div>
                      </div>
                      <div class="actions" v-if="!isMobile">
                        <div class="view" v-on:click="view(item)">
                          {{ $t('helper.visualizar') }}
                        </div>
                        <div
                          class="editar"
                          v-if="item.status !== 'concluded'"
                          v-on:click="concluir(item.id)"
                        >
                          {{ $t('helper.concluir') }}
                        </div>
                      </div>
                      <div class="actions2" v-if="isMobile">
                        <div class="view" v-on:click="view(item)">
                          {{ $t('helper.visualizar') }}
                        </div>
                        <div
                          class="editar"
                          v-if="item.status !== 'concluded'"
                          v-on:click="concluir(item.id)"
                        >
                          {{ $t('helper.concluir') }}
                        </div>
                      </div>
                      <div v-if="item.active">
                        <div class="header2">{{ $t('helper.membro') }}</div>
                        <div class="logox">
                          <img
                            :src="item.last_message.member.picture"
                            alt="img"
                          />
                        </div>
                        <div class="txt">
                          {{ item.last_message.member.name }}
                        </div>
                      </div>
                      <div v-if="item.active && !isMobile">
                        <div class="header2">{{ $t('helper.mensagem') }}</div>
                        <div class="txt">{{ item.last_message.message }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="paginacao" v-if="lastPage !== 1">
                    <div class="txtPaginacao" @click="selectPage('prev')">
                      {{ $t('helper.pagination1') }}
                    </div>
                    <div class="txtPaginacao" @click="selectPage('next')">
                      {{ $t('helper.pagination2') }}
                    </div>
                  </div>
                </div>
                <div v-else>
                  <p class="textVazio">{{ $t('helper.nenhum') }}</p>
                </div>
              </div>
            </div>
          </div>
        </span>
        <div class="d-flex justify-content-center mt-5" v-if="loading">
          <b-spinner label="Loading..."></b-spinner>
        </div>
      </div>
      <b-modal id="modal-new-helper" size="lg" hide-footer>
        <div class="spaceModal">
          <p class="title">{{ $t('helper.modal.title') }}</p>
          <p class="subtitle">
            {{ $t('helper.modal.subtitle') }}
          </p>

          <div class="spaceInputs">
            <b-form-group :label="$t('helper.modal.input1')" label-for="capa">
              <b-form-input
                v-model="titleChamado"
                :placeholder="$t('helper.modal.input1')"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="spaceInputs">
            <b-form-group :label="$t('helper.modal.input2')" label-for="capa">
              <b-form-textarea
                id="textarea"
                v-model="descricaoChamado"
                :placeholder="$t('helper.modal.input2')+'...'"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </div>

          <div class="spaceFooter">
            <button class="btnSave2" @click="saveInitialChamado">
              {{ $t('helper.modal.btn_submit') }}
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-new-mensages" size="lg" hide-footer>
        <div class="spaceModal">
          <p class="title">{{ rowSelected.subject }}</p>
          <!-- <p class="subtitle">Cliente: {{ rowSelected.name_member_chatting }}</p> -->
          <p class="subtitle" v-if="rowSelected.status === 'open'">
            {{ $t('helper.status') }}: {{ $t('helper.aberto') }}
            <svg
              width="5"
              height="5"
              viewBox="0 0 5 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2.5" cy="2.5" r="2.5" fill="#FFCB37" />
            </svg>
          </p>
          <p class="subtitle" v-else-if="rowSelected.status === 'concluded'">
            {{ $t('helper.status') }}: {{ $t('helper.status') }}
            <svg
              width="5"
              height="5"
              viewBox="0 0 5 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2.5" cy="2.5" r="2.5" fill="#00E4A0" />
            </svg>
          </p>
          <p class="subtitle" v-else>{{ $t('helper.status') }}: {{ rowSelected.status }}</p>
          <p class="subtitle">{{ $t('helper.solicitante') }}: {{ solicitante }}</p>

          <div class="spaceInputs">
            <b-form-group label="Mensagens do Chamado" label-for="capa">
              <div id="spaceMsgs" class="spaceMsgs">
                <infinite-loading direction="top" @infinite="infiniteHandler">
                  <div slot="spinner">{{ $t('helper.modal.loading') }}...</div>
                  <div slot="no-more">{{ $t('helper.modal.sem_mensagem') }}</div>
                  <div slot="no-results">{{ $t('helper.modal.sem_mensagem') }}</div>
                </infinite-loading>
                <div
                  v-for="(mensagem, index) in getUnicChamado"
                  :key="mensagem.id"
                  :class="{
                    isMineLeft: mensagem.is_mine,
                    isNotMineLeft: !mensagem.is_mine,
                  }"
                >
                  <div v-if="mensagem.message !== null">
                    <div
                      class="headerMsg"
                      :class="{ mobileHeaderSpace: isMobile }"
                      v-if="
                        mensagem.is_mine &&
                        index > 0 &&
                        mensagem.is_mine !== getUnicChamado[index - 1].is_mine
                      "
                    >
                      <div class="textInfoMember">
                        <div class="text1">{{ mensagem.member.name }}</div>
                        <div class="text2">
                          {{
                            mensagem.created_at
                              | moment("DD/MM/YYYY HH:mm:ss")
                          }}
                        </div>
                      </div>
                      <div
                        class="fotoPerfil"
                        :class="{ isMinePic: mensagem.is_mine }"
                      >
                        <img :src="mensagem.member.picture" alt="perfil" />
                      </div>
                    </div>
                    <div
                      class="headerMsg2"
                      :class="{ mobileHeaderSpace: isMobile }"
                      v-else-if="
                        !mensagem.is_mine &&
                        index > 0 &&
                        mensagem.is_mine !== getUnicChamado[index - 1].is_mine
                      "
                    >
                      <div
                        class="fotoPerfil"
                        :class="{ isMinePic: mensagem.is_mine }"
                      >
                        <img :src="mensagem.member.picture" alt="perfil" />
                      </div>
                      <div class="textInfoMember">
                        <div class="text1">{{ mensagem.member.name }}</div>
                        <div class="text2">
                          {{
                            mensagem.created_at
                              | moment("DD/MM/YYYY HH:mm:ss")
                          }}
                        </div>
                      </div>
                    </div>
                    <p
                      class="txtMsg animationOpacity"
                      :class="{
                        isMineColor: mensagem.is_mine,
                        isNotMineColor: !mensagem.is_mine,
                        chatMobile: isMobile,
                      }"
                    >
                      {{ mensagem.message }}
                    </p>
                  </div>

                  <div
                    v-else
                    :class="{
                      imgDivMsgMy: mensagem.is_mine,
                      imgDivMsg: !mensagem.is_mine,
                    }"
                  >
                    <!-- <img class="spaceImg animationOpacity" :src="mensagem.media_url" alt="Imagem"> -->
                    <Lightbox
                      :thumbnail="mensagem.media_url"
                      :images="mensagem.media_url"
                    ></Lightbox>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>

          <div class="spaceInputs" v-if="rowSelected.status !== 'concluded'">
            <b-form-textarea
              id="textarea"
              v-model="descricaoChamado"
              :placeholder="$t('helper.modal.input3')"
              class="textAreaComment animationOpacity"
              rows="3"
              max-rows="6"
              v-on:keyup.enter="createMsg"
              v-if="!midiaUpload"
            ></b-form-textarea>
            <vue-upload-multiple-image
              v-if="midiaUpload"
              class="animationOpacity toCenterUpload"
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
              @edit-image="editImage"
              @data-change="dataChange"
              :data-images="images"
              :multiple="false"
              :primaryText="''"
              :popupText="$t('helper.modal.input4')"
              :dragText="$t('helper.modal.input5')"
              :browseText="$t('helper.modal.input6')"
            ></vue-upload-multiple-image>
          </div>
          <div
            class="spaceFooter notSpaceFooter animationOpacity"
            v-if="rowSelected.status !== 'concluded'"
          >
            <button
              class="btnSave3"
              v-if="!midiaUpload"
              @click="midiaUpload = true"
            >
              <svg
                width="22"
                height="21"
                viewBox="0 0 22 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 12C16.7348 12 16.4804 12.1054 16.2929 12.2929C16.1054 12.4804 16 12.7348 16 13V13.38L14.52 11.9C13.9974 11.3815 13.2911 11.0906 12.555 11.0906C11.8189 11.0906 11.1126 11.3815 10.59 11.9L9.89 12.6L7.41 10.12C6.88012 9.61562 6.17657 9.33432 5.445 9.33432C4.71343 9.33432 4.00988 9.61562 3.48 10.12L2 11.6V6.00002C2 5.7348 2.10536 5.48045 2.29289 5.29291C2.48043 5.10538 2.73478 5.00002 3 5.00002H10C10.2652 5.00002 10.5196 4.89466 10.7071 4.70713C10.8946 4.51959 11 4.26524 11 4.00002C11 3.7348 10.8946 3.48045 10.7071 3.29291C10.5196 3.10538 10.2652 3.00002 10 3.00002H3C2.20435 3.00002 1.44129 3.31609 0.87868 3.8787C0.31607 4.44131 0 5.20437 0 6.00002V18C0 18.7956 0.31607 19.5587 0.87868 20.1213C1.44129 20.6839 2.20435 21 3 21H15C15.7956 21 16.5587 20.6839 17.1213 20.1213C17.6839 19.5587 18 18.7956 18 18V13C18 12.7348 17.8946 12.4804 17.7071 12.2929C17.5196 12.1054 17.2652 12 17 12ZM3 19C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V14.43L4.9 11.53C5.04691 11.39 5.24206 11.3119 5.445 11.3119C5.64794 11.3119 5.84309 11.39 5.99 11.53L9.16 14.7L13.46 19H3ZM16 18C15.9986 18.1914 15.9354 18.3773 15.82 18.53L11.31 14L12.01 13.3C12.0817 13.2268 12.1673 13.1687 12.2617 13.129C12.3561 13.0893 12.4576 13.0689 12.56 13.0689C12.6624 13.0689 12.7639 13.0893 12.8583 13.129C12.9527 13.1687 13.0383 13.2268 13.11 13.3L16 16.21V18ZM20.71 3.29002L17.71 0.290019C17.6149 0.198979 17.5028 0.127609 17.38 0.0800191C17.1365 -0.0199999 16.8635 -0.0199999 16.62 0.0800191C16.4972 0.127609 16.3851 0.198979 16.29 0.290019L13.29 3.29002C13.1968 3.38326 13.1228 3.49395 13.0723 3.61577C13.0219 3.73759 12.9959 3.86816 12.9959 4.00002C12.9959 4.26632 13.1017 4.52172 13.29 4.71002C13.4783 4.89832 13.7337 5.00411 14 5.00411C14.2663 5.00411 14.5217 4.89832 14.71 4.71002L16 3.41002V9.00002C16 9.26522 16.1054 9.51962 16.2929 9.70712C16.4804 9.89462 16.7348 10 17 10C17.2652 10 17.5196 9.89462 17.7071 9.70712C17.8946 9.51962 18 9.26522 18 9.00002V3.41002L19.29 4.71002C19.383 4.80375 19.4936 4.87814 19.6154 4.92891C19.7373 4.97968 19.868 5.00582 20 5.00582C20.132 5.00582 20.2627 4.97968 20.3846 4.92891C20.5064 4.87814 20.617 4.80375 20.71 4.71002C20.8037 4.61706 20.8781 4.50645 20.9289 4.3846C20.9797 4.26274 21.0058 4.13203 21.0058 4.00002C21.0058 3.86801 20.9797 3.7373 20.9289 3.61544C20.8781 3.49358 20.8037 3.38298 20.71 3.29002Z"
                  :fill="setColor()"
                />
              </svg>
            </button>
            <button
              class="btnSave3"
              v-if="midiaUpload"
              @click="midiaUpload = false"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 18H3"
                  stroke="#00E4A0"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 14H3"
                  stroke="#00E4A0"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17 10H3"
                  stroke="#00E4A0"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 6H3"
                  stroke="#00E4A0"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button class="btnSave2" v-if="!midiaUpload" @click="createMsg">
              {{$t('helper.modal.input7')}}
            </button>
            <button class="btnSave2" v-if="midiaUpload" @click="createMsgImg">
              {{$t('helper.modal.input8')}}
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import TicketService from "@/services/resources/TicketService";
const serviceTicket = TicketService.build();
import Cookies from "js-cookie";
import InfiniteLoading from "vue-infinite-loading";
import Slidebar from "@/components/Slidebar.vue";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import TicketComponentV2 from "@/components/V2/TicketComponent.vue";
export default {
  components: {
    VueUploadMultipleImage,
    InfiniteLoading,
    Slidebar,
    TicketComponentV2, 
    Lightbox: () => import("@/components/Lightbox.vue"),
    HelperComponentV2: () => import("@/components/V2/HelperComponent.vue"),
  },

  data() {
    return {
      users: [],
      client: {
        width: 0,
      },
      images: [],
      AllChamados: [],
      titleChamado: "",
      descricaoChamado: "",
      getUnicChamado: [],
      lastPage: 1,
      currentPage: 1,
      permission: false,
      midiaUpload: false,
      searchTicket: "",
      selectedList: "",
      firstName: "",
      phone: "",
      rowSelected: [],
      pageTicket: 1,
      solicitante: "",
      customHelper: false,
      linkIframe: null,
      siteId: 0,
      loading:false,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  computed: {
    currentSite() { 
      return this.$store.getters.currentSite;
    },
    isMobile() {
      return this.client.width <= 576;
    },
    clubVersion() {
      return this.$store.state.globalSettings.clubVersion;
    },
  },
  methods: {
    setColor(){
      if(getComputedStyle(document.documentElement).getPropertyValue('--maincolor')){
        return getComputedStyle(document.documentElement).getPropertyValue('--maincolor')
      }
    },
    toggleActive(index) {
      let item = this.AllChamados[index];
      item.active = !item.active;
      this.$set(this.AllChamados, index, item);
    },
    getList(data) {
      this.selectedList = data;
      this.currentPage = 1;
      this.getAllChamado();
    },
    uploadImageSuccess(formData, index, fileList) {
      //console.log("data", fileList[0]);
      this.imageSelected = fileList[0];
    },
    beforeRemove(index, done, fileList) {
      //console.log("index", index, fileList);
      var r = confirm(this.$t('helper.modal.remove_image'));
      if (r == true) {
        done();
      }
    },
    editImage(formData, index, fileList) {
      //console.log("edit data", formData, index, fileList);
    },
    dataChange(data) {
      //console.log(data);
    },
    openSendImage() {},
    selectPage(to) {
      if (to === "next") {
        if (this.currentPage == this.lastPage) {
        } else {
          this.currentPage++;
          this.getAllChamado("");
          return;
        }
      } else {
        if (this.currentPage === 1) {
        } else {
          this.currentPage--;
          this.getAllChamado("");
          return;
        }
      }
    },
    scroll() {
      setTimeout(() => {
        var objScrDiv = document.getElementById("spaceMsgs");
        //console.log(objScrDiv);
        objScrDiv.scrollTop = objScrDiv.scrollHeight;
      }, 1000);
    },
    infiniteHandler($state) {
      this.pageTicket += 1;
      serviceTicket
        .read(this.rowSelected.id + "?page=" + this.pageTicket)
        .then((resp) => {
          //console.log(resp);
          if (resp.data.length) {
            this.getUnicChamado.unshift(...resp.data.reverse());
            $state.loaded();
          } else {
            $state.complete();
          }
          this.loading = false;
        })
        .catch((err) => {
          //console.log(err);
          this.loading = false;
        });
    },
    view(allRow) {
      this.rowSelected = allRow;
      this.solicitante = allRow.member.name;
      serviceTicket
        .read(allRow.id)
        .then((resp) => {
          //console.log("get unic chamado", resp);
          this.getUnicChamado = resp.data.reverse();
          this.$root.$emit("bv::show::modal", "modal-new-mensages", "#btnShow");
          this.loading = false;
          this.scroll();
        })
        .catch((err) => {
          //console.log(err);
          this.loading = false;
        });
    },
    createMsgImg() {
      this.loading = true;
      let data = {
        id: this.rowSelected.id + "/message",
        media: this.imageSelected.path,
      };
      serviceTicket
        .postID(data)
        .then((resp) => {
          //console.log("create image ticket", resp);
          this.view(this.rowSelected);
          this.descricaoChamado = "";
          this.imageSelected = {};
          this.images = [];
          this.$root.$emit("bv::hide::modal", "modal-new-helper", "#btnShow");
          this.loading = false;
        })
        .catch((err) => {
          //console.log(err);
          this.loading = false;
        });
    },
    createMsg() {
      this.loading = true;
      let data = {
        id: this.rowSelected.id + "/message",
        message: this.descricaoChamado,
      };
      serviceTicket
        .postID(data)
        .then((resp) => {
          //console.log("create mensage ticket", resp);
          this.view(this.rowSelected);
          this.descricaoChamado = "";
          this.imageSelected = {};
          this.images = [];
          this.$root.$emit("bv::hide::modal", "modal-new-helper", "#btnShow");
          this.loading = false;
        })
        .catch((err) => {
          //console.log(err);
          this.loading = false;
        });
    },
    concluir(idRow) {
      let data = {
        id: idRow,
        status: "concluded",
      };
      this.loading = true;
      serviceTicket
        .postID(data)
        .then((resp) => {
          //console.log("concluir chamado", resp);
          this.getAllChamado("");
          this.loading = false;
        })
        .catch((err) => {
          //console.log(err);
          this.loading = false;
        });
    },
    getAllChamado(searchFunc) {
      this.loading = true;

      var dataUrl = "";
      if (searchFunc === "search") {
        dataUrl = "search_string=" + this.searchTicket;
      } else {
        if (this.selectedList === "") {
          dataUrl = "page=" + this.currentPage;
        } else {
          dataUrl =
            "status[]=" + this.selectedList + "&page=" + this.currentPage;
        }
      }

      serviceTicket
        .search(dataUrl)
        .then((resp) => {
          //console.log("get all ticket", resp);
          this.AllChamados = resp.data;
          this.currentPage = resp.current_page;
          this.lastPage = resp.last_page;
          this.loading = false;
        })
        .catch((err) => {
          //console.log(err);
          this.loading = false;
        });
    },
    saveInitialChamado() {
      this.loading = true;
      serviceTicket
        .create({ subject: this.titleChamado })
        .then((resp) => {
          //console.log("create ticket", resp);

          let data = {
            id: resp.id + "/message",
            message: this.descricaoChamado,
          };
          serviceTicket
            .postID(data)
            .then((resp) => {
              //console.log("create mensage ticket", resp);
              this.getAllChamado("");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-new-helper",
                "#btnShow"
              );
              this.descricaoChamado = "";
              this.imageSelected = {};
              this.images = [];
              this.loading = false;
            })
            .catch((err) => {
              //console.log(err);
              this.loading = false;
            });
        })
        .catch((err) => {
          //console.log(err);
          this.loading = false;
        });
    },
    handleResize() {
      this.client.width = window.innerWidth;
    },
    openModal() {
      this.$root.$emit("bv::show::modal", "modal-new-helper", "#btnShow");
    },
    getPermission() {
      let permission = Cookies.get("access_level");
      let typeView = Cookies.get("type_student");
      if (permission === "admin" || permission === "owner") {
        if (typeView === 1 || typeView === "1") {
          this.permission = false;
          return;
        }
        this.permission = true;
      } else {
        this.permission = false;
      }
    },
    async getLinkAjudaExterna() {
      let resp = await this.$store.dispatch("fetchMetas", ["external_help_link"])
      //console.log("meta external_help_link", resp);
      var data = resp.external_help_link;
      var parans = "";
      if (this.siteId === 5) {
        parans = `?fn=${this.firstName}&em=${this.email}&token=w46wQyKD38SW&ph=${this.phone}`;
      }
      this.linkIframe = data + parans;
    },
    getCurrentSiteAndMember() {
      this.firstName = this.currentSite.currentMember.name;
      this.email = this.currentSite.currentMember.email;
      this.phone = this.currentSite.currentMember.email;
      this.siteId = this.currentSite.currentSite.id;
      this.getLinkAjudaExterna();
    },
    async getAjudaExterna() {
      let resp = await this.$store.dispatch("fetchMetas", ["external_help"])
      var data = resp.external_help;
      if (data === "on") {
        this.customHelper = true;
        this.getCurrentSiteAndMember();
      }
    },
  },
  mounted() {
    this.getAllChamado("");
    this.getPermission();
    this.getAjudaExterna();
    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-new-mensages") {
        this.getAllChamado("");
        this.pageTicket = 1;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.activeRow {
  height: auto !important;
  border-left: solid var(--maincolor) 4px;
  border-radius: 4px;
  padding: 4px;
}

.textToTutors p {
  font-size: 15px;
  font-family: Montserrat;
}
.textToTutors a {
  text-decoration: none;
  font-weight: 600;
  color: var(--maincolor);
}

.activeList {
  color: var(--maincolor) !important;
  transition: 0.3s;
  background: #f9f9f92b;
  border-radius: 3px;
  border: 1px solid var(--maincolor);
  svg {
    path {
      stroke: var(--maincolor) !important;
    }
  }
}

.header2 {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.2px;
  color: var(--fontcolor);
  margin-bottom: 10px;
}

.logox {
  margin-bottom: 5px;
  cursor: pointer;
  width: 45px;
  height: 45px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  img {
    width: 100%;
    border-radius: 100%;
  }
}

.gridListMenu {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: -50px;
  position: absolute;
  right: 20px;
  .menu {
    cursor: pointer;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    justify-items: start;
    color: var(--fontcolor);
    padding: 7px;
    transition: 0.5s;
    justify-self: center;
  }
}
.gridListMenuMobile {
  .menu {
    cursor: pointer;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    justify-items: start;
    color: var(--fontcolor);
    padding: 7px;
    transition: 0.5s;
    justify-self: center;
  }
}

.spaceHelper {
  width: 100%;
  padding: 0 44px 0 44px;
  padding-top: 70px;
  min-height: 100vh;

  iframe {
    position: absolute;
    left: 0;
    // padding-left: 98px;
    min-height: 100vh;

    top: 0;
  }
}

.tosearch {
  .inputSearch {
    position: relative;
    margin-left: 0px;
    margin-bottom: 20px;
    width: 450px;
  }
  .input-busca {
    width: 100%;
    height: 60px;
    background: #ffffff;
    border: solid 1px var(--bordercolor);
    border-radius: 5px;
    padding: 20px 30px;
    font-family: Montserrat;
    font-weight: normal;
    color: #81858e;
    font-size: 14px;
    transition: 0.3s;
  }
  .input-busca:hover,
  .input-busca:focus {
    box-shadow: 0 6px 12px rgba(30, 60, 90, 0.2);
  }
  .search {
    position: absolute;
    right: 25px;
    top: 24px;
    width: 14.7px;
    height: 14.7px;
    z-index: 999;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    cursor: pointer;
  }
}

.spaceHelperMobile {
  width: 100vh;
  // padding: 15px;
  // padding-top: 70px;
  min-height: 100vh;
  iframe {
    position: absolute;
    left: 0;
    height: 100%;
    // top: 51px;
    min-height: 100vh;
  }
}

.spaceTitle {
  p {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 800;
    font-size: 32px;
    color: var(--fontcolor);
    white-space: nowrap;
  }
}

.spaceDados {
  .headerFlex {
    margin-top: 30px;
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .headerFlexMobile {
    margin-top: 40px;
    margin-bottom: 30px;
    width: 100%;
    display: block;
    justify-content: space-between;
  }
  .btnNewChamado {
    width: 242.92px;
    height: 45px;
    background: var(--maincolor);
    border-radius: 5px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    border: none;
  }
  .title {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: var(--fontcolor);
  }
  .spaceTable {
    margin-top: 30px;
    margin-bottom: 30px;
    .paginacao {
      width: 100%;
      justify-content: space-around;
      display: flex;
      margin-top: 20px;
      margin-bottom: 30px;
      .txtPaginacao {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: var(--fontcolor);
        cursor: pointer;
      }
      .txtPaginacao:hover {
        color: var(--maincolor);
      }
    }
    .header {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
      margin-bottom: 25px;
      div {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.2px;
        color: var(--fontcolor);
      }
    }
    .headerMobile {
      padding-top: 40px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      margin-bottom: 25px;
      gap: 17px;
      div {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 0.8em;
        letter-spacing: 0.2px;
        color: var(--fontcolor);
        white-space: nowrap;
      }
    }
    .itens {
      .spaceItens {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
        height: 40px;
        border-bottom: 0.5px solid #ededf0;
        margin: 15px 5px;
        transition: 1s;
        row-gap: 20px;
      }
      .spaceItensMobile {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        height: 55px;
        border-bottom: 0.5px solid #ededf0;
        margin: 20px 5px;
        padding-bottom: 5px;
      }
      .flexPointer {
        display: flex;
      }
      .pointerMsg {
        background: var(--maincolor);
        box-shadow: 0px 0px 10px var(--maincolortrans);
        width: 7px;
        height: 7px;
        border-radius: 100%;
        position: relative;
        top: 6px;
        margin-right: 8px;
      }
      .txt {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        letter-spacing: 0.2px;
        color: #81858e;
        cursor: pointer;
      }
      .txt2 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        letter-spacing: 0.2px;
        color: #81858e;
        cursor: pointer;
      }
      .actions {
        display: flex;
        .editar {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          letter-spacing: 0.2px;
          color: var(--maincolor);
          cursor: pointer;
          margin-left: 15px;
        }
        .view {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          letter-spacing: 0.2px;
          color: #81858e;
          cursor: pointer;
        }
      }
      .actions2 {
        .editar {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          letter-spacing: 0.2px;
          color: var(--maincolor);
          cursor: pointer;
        }
        .view {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          letter-spacing: 0.2px;
          color: #81858e;
          cursor: pointer;
        }
      }
    }
  }
}

.textVazio {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.2px;
  color: var(--fontcolor);
}

.containerx {
  width: 97%;
}

.slidebarMobile {
  float: right;
  padding-top: 20px;
  position: relative;
  right: 0.6em;
}

.spaceInputs {
  margin-bottom: 30px;
  .toCenterUpload {
    display: flex;
    justify-content: center;
  }
  .textInfo {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #81858e;
    margin-top: 5px;
  }
  .btn-criar {
    background: var(--maincolor);
    border: 1px solid var(--maincolor);
    box-sizing: border-box;
    box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
    border-radius: 5px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    width: 100%;
    height: 55px;
    margin-top: 40px;
  }
  .btn-openModalPreview {
    background: var(--maincolortrans);
    border: 2px dashed var(--maincolor);
    box-sizing: border-box;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
    img {
      border-radius: 3px;
    }
    .imagePreviewCapa {
      width: 100px;
      height: 100px;
      border-radius: 3px;
      overflow: hidden;
    }
  }
  .btn-openModal {
    background: var(--maincolortrans);
    border: 2px dashed var(--maincolor);
    box-sizing: border-box;
    border-radius: 5px;
    height: 55px;
    cursor: pointer;
    .text {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      color: var(--maincolor);
      display: flex;
      justify-content: center;
      margin-top: 17px;
    }
  }
  .gerenciarCat {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.2px;
    color: var(--maincolor);
    position: absolute;
    right: 3em;
    cursor: pointer;
  }
  select {
    border: 1px solid var(--bordercolor);
    box-sizing: border-box;
    border-radius: 5px;
    height: 55px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #6d767e;
    overflow: hidden !important;
    resize: none !important;
  }
  input,
  textarea {
    border: 1px solid var(--bordercolor);
    box-sizing: border-box;
    border-radius: 5px;
    height: 55px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
    overflow: hidden !important;
    resize: none !important;
    background: white;
  }
  input:hover,
  select:hover,
  textarea:hover,
  input:focus,
  select:focus,
  textarea:focus {
    border: 1px solid var(--maincolor);
    box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
  }
  label {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
  }
}

.spaceModal {
  padding: 0 20px 20px 20px;
  margin-top: -20px;
  .textAreaComment {
    display: block !important;
    width: 100% !important;
    border: none !important;
    border-bottom: 0.5px solid #ededf0 !important;
    padding: 5px 25 !important;
    padding-right: 20px !important;
    padding-top: 10px !important;
    font-size: 13px !important;
    background: var(--backgroundcolor) !important;
    color: var(--fontcolor2) !important;
  }
  .spaceMsgs::-webkit-scrollbar {
    background-color: #fff;
    width: 2px;
  }

  .spaceMsgs::-webkit-scrollbar-track {
    background-color: #c7c7c7;
  }

  .spaceMsgs::-webkit-scrollbar-thumb {
    background-color: #4d4d4d52;
    border-radius: 31px;
  }

  .spaceMsgs::-webkit-scrollbar-button {
    display: none;
  }
  .spaceMsgs {
    width: 100%;
    height: 35vh;
    overflow: auto;
    border-left: solid 1px var(--bordercolor);
    border-top: solid 1px var(--bordercolor);
    border-right: solid 1px var(--bordercolor);
    border-radius: 5px;
    padding: 20px;
    .headerMsg {
      display: grid;
      grid-template-columns: 2fr 1fr;
      gap: 14px;
      margin-bottom: 5px;
    }
    .headerMsg2 {
      display: grid;
      grid-template-columns: 1fr 2fr;
      gap: 14px;
      margin-bottom: 5px;
    }
    .mobileHeaderSpace {
      margin-top: 20px;
    }
    .isMinePic {
      margin-left: auto;
    }
    .textInfoMember {
      .text1 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        letter-spacing: 0.2px;
        color: #333333;
      }
      .text2 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        letter-spacing: 0.2px;
        color: #333333;
      }
    }
    .fotoPerfil {
      width: 35px;
      height: 35px;
      img {
        width: 100%;
        border-radius: 100%;
      }
    }
    .imgDivMsgMy {
      width: 200px;
      background: #e8eafa;
      padding: 7px;
      border-radius: 3px;
      margin-bottom: 5px;
    }
    .imgDivMsg {
      width: 200px;
      background: #ededf0;
      padding: 7px;
      border-radius: 3px;
      margin-bottom: 5px;
    }
    .spaceImg {
      border-radius: 3px;
      width: 100%;
    }
    .isMineLeft {
      justify-content: flex-end;
      display: flex;
    }
    .isNotMineLeft {
      justify-content: flex-start;
      display: flex;
    }
    .chatMobile {
      left: 0 !important;
      right: 0 !important;
    }
    .isMineColor {
      background: rgba(33, 51, 210, 0.1);
      border-radius: 3px;
      padding: 6px;
      color: var(--fontcolor2) !important;
      width: fit-content;
      margin-left: auto;
      position: relative;
      right: 35px;
      top: 10px;
    }
    .isNotMineColor {
      background: #ededf0;
      border-radius: 3px;
      padding: 6px;
      position: relative;
      top: 10px;
      left: 35px;
    }
    .txtMsg {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      margin-bottom: 6px;
      box-shadow: 0px 4px 10px #88888817;
    }
  }
  .notSpaceFooter {
    margin-top: -20px;
  }
  .spaceFooter {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    .btnSave {
      border: none;
      width: 326.61px;
      height: 55px;
      background: #00e4a0;
      border-radius: 5px;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
    }
    .btnSave2 {
      height: 40px;
      background: var(--maincolortrans);
      border-radius: 3px;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      padding: 0 15px;
      font-size: 13px;
      color: var(--maincolor);
      border: none;
    }
    .btnSave3 {
      height: 40px;
      background: rgba(33, 51, 210, 0.1);
      border-radius: 3px;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      padding: 0 15px;
      font-size: 13px;
      color: #2133d2;
      border: none;
      margin-right: 10px;
    }
  }
  .title {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 800;
    font-size: 18px;
    letter-spacing: 0.2px;
    color: var(--fontcolor);
  }
  .subtitle {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    letter-spacing: 0.2px;
    color: #81858e;
    margin-top: -15px;
    margin-bottom: 20px;
  }
}
</style>
